export const enum AssetType {
  CONTEST_THUMBNAIL = 'CONTEST_THUMBNAIL',
  CONTEST_BANNER = 'CONTEST_BANNER',
}
